import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Field, FieldProps, Form, Formik, FormikProps, FormikValues } from "formik";
import Header from "user/components/common/Header";
import { terms } from "./-components/terms";
import TermsDetail from "./-components/TermsDetail";
import Checkbox from "user/components/form/Checkbox";
import { ReactComponent as RightArrow } from "../../assets/icons/rightArrow.svg";

export type TermsProps = {
    label: string;
    name: string;
    content: string;
};
type InitialValuesProps = {
    all: boolean;
    term1: boolean;
    term2: boolean;
    term3: boolean;
    term4: boolean;
};

const initialValues: InitialValuesProps = {
    all: false,
    term1: false,
    term2: false,
    term3: false,
    term4: false,
};

export default function TermsAndConditions() {
    const [viewTermsDetail, setViewTermsDetail] = useState<TermsProps | null>(null);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const navigate = useNavigate();

    // 전체 항목 체크할 시 전체 동의 체크
    useEffect(() => {
        const formik = formikRef.current;
        if (formik) {
            const { term1, term2, term3, term4 } = formik.values;
            if (term1 && term2 && term3 && term4) {
                formikRef.current?.setFieldValue("all", true);
            }
        }
    }, [formikRef.current]);

    const onSubmit = () => {
        navigate("/signup");
    };

    return (
        <div className={`min-h-[100dvh] flex flex-col relative ${viewTermsDetail ? "max-h-[100dvh] overflow-hidden" : "max-h-none"}`}>
            <Header title="약관동의" goBack />
            <div className="wrapper pt-[26px] pb-[16px] flex-1 flex flex-col gap-[40px] [&_form]:flex-1 [&_form]:flex [&_form]:flex-col">
                <p className="font-bold text-[24px] leading-[36px]">
                    반갑습니다!
                    <br />
                    이용 약관에 동의해주세요.
                </p>

                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    validateOnMount
                    validate={values => {
                        const errors: Record<string, string> = {};
                        if (!values.term1) {
                            errors.term1 = "필수 항목 체크해주세요.";
                        }
                        if (!values.term2) {
                            errors.term2 = "필수 항목 체크해주세요.";
                        }
                        if (!values.term3) {
                            errors.term3 = "필수 항목 체크해주세요.";
                        }
                        if (!values.term4) {
                            errors.term4 = "필수 항목 체크해주세요.";
                        }

                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(true);
                        onSubmit();
                    }}
                >
                    {({ isSubmitting, errors, values, setFieldValue, setValues }) => {
                        const errorKeys = Object.keys(errors);
                        const isInValid = errorKeys.length > 0;
                        // console.log(values);

                        return (
                            <Form>
                                <div className="flex flex-col justify-between flex-1">
                                    <div>
                                        <div className="border-b border-[#dddddd] leading-[30px] py-[12px] text-[20px] font-[500] flex gap-[10px] items-center">
                                            <Field name="all">
                                                {({ field }: FieldProps) => {
                                                    return (
                                                        <Checkbox
                                                            id="all"
                                                            type="round"
                                                            checked={field.value}
                                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                                const checked = event.target.checked;

                                                                setValues({
                                                                    all: checked,
                                                                    term1: checked,
                                                                    term2: checked,
                                                                    term3: checked,
                                                                    term4: checked,
                                                                });
                                                            }}
                                                        />
                                                    );
                                                }}
                                            </Field>

                                            <label htmlFor="all">전체 동의</label>
                                        </div>

                                        <ul>
                                            {terms.map((item, index) => {
                                                return (
                                                    <li
                                                        key={index}
                                                        className="p-[12px] flex gap-2 items-center justify-between"
                                                        onClick={() => setViewTermsDetail(item)}
                                                    >
                                                        <div className="flex items-center gap-2">
                                                            <Field name={item.name}>
                                                                {({ field }: FieldProps) => {
                                                                    return (
                                                                        <Checkbox
                                                                            id={item.name}
                                                                            type="line"
                                                                            checked={field.value}
                                                                            readOnly
                                                                        />
                                                                    );
                                                                }}
                                                            </Field>
                                                            <p className="text-lg cursor-default">{item.label}</p>
                                                        </div>
                                                        <RightArrow />
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={isInValid}
                                        className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] disabled:opacity-[0.3]"
                                    >
                                        다음
                                    </button>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>

            {viewTermsDetail && (
                <TermsDetail
                    detail={viewTermsDetail}
                    setDetail={setViewTermsDetail}
                    onClickAgree={() => {
                        if (formikRef.current) {
                            formikRef.current.setFieldValue(viewTermsDetail.name, true);
                        }
                        setViewTermsDetail(null);
                    }}
                />
            )}
        </div>
    );
}
